import { render, staticRenderFns } from "./internalAccountManger.vue?vue&type=template&id=4b7ddc94&scoped=true"
import script from "./internalAccountManger.vue?vue&type=script&lang=js"
export * from "./internalAccountManger.vue?vue&type=script&lang=js"
import style0 from "./internalAccountManger.vue?vue&type=style&index=0&id=4b7ddc94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ddc94",
  null
  
)

export default component.exports